import { skeletonColor } from 'constant';

import { Flex, HStack, Skeleton, useTheme, VStack } from '@chakra-ui/react';

const ProductShopListSkeleton = () => {
  const {
    colors: {
      palette: {
        shop: {
          products: {
            listStep: {
              listContainer: { container: styles }
            }
          }
        }
      }
    }
  } = useTheme();

  return (
    <VStack gap={0} w='full' shadow='sm'>
      <HStack
        gap={0}
        w='full'
        h={{ base: 'auto', md: '350px' }}
        borderRadius='3px'
        overflow='hidden'
        bg={styles.productBg}
      >
        <Skeleton
          borderRadius={{ base: '6px', md: 0 }}
          mt={{ base: '24px', md: 0 }}
          alignSelf={{ base: 'flex-start', md: 'auto' }}
          ml={{ base: '16px', md: 0 }}
          w={{ base: '150px', md: '35%', lg: '50%' }}
          height={{ base: '150px', md: 'full' }}
          variant='shine'
          startColor={skeletonColor.start}
          endColor={skeletonColor.end}
        />

        <VStack
          h='full'
          w={{ md: '100%', lg: '50%' }}
          px={{ base: '16px', md: '30px' }}
          pt={{ base: '24px', md: '27px' }}
          pb={{ base: '16px', md: '36px' }}
          gap={{ base: '16px', md: '8px' }}
          alignItems='flex-start'
          justifyContent='space-between'
          flex={1}
        >
          <VStack
            gap='8px'
            minH={{ base: '150px', md: 'auto' }}
            alignItems='flex-start'
            w='full'
          >
            <Skeleton
              w='80%'
              height='20px'
              variant='shine'
              startColor={skeletonColor.start}
              endColor={skeletonColor.end}
            />
            <Skeleton
              mt='2px'
              w='50%'
              height='13px'
              variant='shine'
              startColor={skeletonColor.start}
              endColor={skeletonColor.end}
            />
            <Skeleton
              w='35%'
              mb='8px'
              mt='3px'
              height='13px'
              variant='shine'
              startColor={skeletonColor.start}
              endColor={skeletonColor.end}
            />

            <Flex
              gap={{ base: '16px', md: '30px' }}
              alignItems='center'
              w='full'
              mt='4px'
            >
              <Skeleton
                mt='2px'
                w={{ base: '75px', md: '90px' }}
                height='22px'
                variant='shine'
                startColor={skeletonColor.start}
                endColor={skeletonColor.end}
              />
              <Skeleton
                w={{ base: '70px', md: '90px' }}
                height='15px'
                variant='shine'
                startColor={skeletonColor.start}
                endColor={skeletonColor.end}
              />
            </Flex>
          </VStack>

          <Flex
            display={{ base: 'none', md: 'flex' }}
            alignItems='flex-end'
            w='full'
            justifyContent='flex-start'
          >
            <Skeleton
              borderRadius='25px'
              h='45px'
              w='164px'
              mr={{ base: '14px', md: 0 }}
              startColor={skeletonColor.start}
              endColor={skeletonColor.end}
            />
          </Flex>
        </VStack>
      </HStack>

      <Flex
        bg={styles.productBg}
        display={{ base: 'flex', md: 'none' }}
        alignItems='flex-end'
        w='full'
        justifyContent={{ base: 'center', sm: 'flex-end' }}
        pb='24px'
        pr={{ base: 0, sm: '16px' }}
      >
        <Skeleton
          borderRadius='25px'
          h='45px'
          w='164px'
          startColor={skeletonColor.start}
          endColor={skeletonColor.end}
        />
      </Flex>
    </VStack>
  );
};

export default ProductShopListSkeleton;
